export function getWordInitials(word = '', limit = 2) {
  const wordInitials = word
    .split(' ')
    .map((word: string) => word.charAt(0))
    .slice(0, limit)
    .join('');

  return wordInitials;
}
